export default __webpack_public_path__ + "static/CevicheOne-Regular-dcb79f1a826c73d1eb5e5697a616ac3d.ttf";